import React, { useEffect } from "react";

/** Keep the customer interface in the single light NAVI CARE theme. */
export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.classList.remove("dark");
    try { localStorage.setItem("nw_theme", "light"); } catch {}
  }, []);
  return children;
}
